<div style="background-color: white;height: 100%;">
  <div class="client_list">
    <div class="client_header">
      <div class="client_details_info">Client Listings</div>
    </div>
    <div class="client_search">
      <mat-form-field class="client_form_fields" appearance="outline">
        <input matInput type="text" placeholder="Search" (input)="applyFilter($event)" />
        <mat-icon matSuffix style="color: black;">search</mat-icon>
      </mat-form-field>
    </div>

    <div class="client_details">
      <div *ngIf="!dataSource || dataSource.data.length == 0 " style="text-align: center;">
        <img src="assets/manager/checklist.svg"  alt="manager_image" class="client_image">
        <div style="font-size: 35px;font-family: var(--font);line-height: 1;color: grey;padding: 20px 0px;">No Client Data Available</div>
      </div>
      <div *ngIf="dataSource.data.length > 0"  class="client_table_details">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="border: 1px solid #ccc;">
          <!-- Business Name Column -->
          <ng-container matColumnDef="ClientName">
            <th mat-header-cell *matHeaderCellDef>Client Name </th>
            <td mat-cell *matCellDef="let element">
              <div class="client_profile_container">
                <img [src]="element.ClientPhoto" alt="Profile Photo" *ngIf="element.isImageAvailable"
                  class="client_profile_photo" />
                <span *ngIf="!element.isImageAvailable" class="manager_image_text">{{element.ManagerImageText}}</span>
                <span>{{element.ClientFullName}}</span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="ClientBusinessName">
            <th mat-header-cell *matHeaderCellDef>Business Name</th>
            <td mat-cell *matCellDef="let element"> {{element.BusinessInfo_BusinessName}} </td>
          </ng-container>
  
          <!-- Business Type Column -->
          <!-- <ng-container matColumnDef="BusinessInfo_BusinessType">
              <th mat-header-cell *matHeaderCellDef> Type </th>
              <td mat-cell *matCellDef="let element"> {{element.BusinessInfo_BusinessType}} </td>
            </ng-container> -->
          <ng-container matColumnDef="ClientEmail">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let element"> {{element.ClientEmail}} </td>
          </ng-container>
  
          <ng-container matColumnDef="ClientNumber">
            <th mat-header-cell *matHeaderCellDef>Mobile No</th>
            <td mat-cell *matCellDef="let element"> {{element.ClientMobileNumber}} </td>
          </ng-container>
  
          <!-- Created On Column -->
          <!-- <ng-container matColumnDef="Created_On">
              <th mat-header-cell *matHeaderCellDef> Added On </th>
              <td mat-cell *matCellDef="let element"> {{element.Created_On | date:'dd - MMM - yyyy'}} </td>
            </ng-container> -->
  
          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let element">
              <button class="request_button" (click)="onButtonClick(element.BusinessInfoId,element.ClientUserId,element.ClientFullName,element.BusinessInfo_BusinessName)" >
                <!-- (click)="sendRequest(element.BusinessInfoId,element.ClientUserId)" -->
                <img src="/assets/send_request_icon.png" alt="send request" style="width: 26px; height: 26px;">
              </button>
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Popup -->
<div *ngIf="isPopupVisible" class="popup_overlay">
  <div class="popup_content">
    <div class="popup_title">Send Request</div>
    <div class="popup_description">Would you like to send request for the client: {{clientname}} of business: {{businessname}}?</div>
    <button class="pop_up_buttons" style=" margin-right: 20px;" (click)="sendRequest()">Send</button>
    <button class="pop_up_buttons" (click)="closePopup()">Cancel</button>
  </div>
</div>

